import { SanitizationConfig } from 'cio/helpers/preview-whitelist';

export function sanitizeElement(element: Element, config: SanitizationConfig) {
  let sanitizer = new window.Sanitize(config);
  let cleaned = document.implementation.createHTMLDocument('sanitizerdoc').body;

  cleaned.appendChild(sanitizer.clean_node(element));
  return cleaned.innerHTML;
}

export function sanitize(html: string, config: SanitizationConfig) {
  return sanitizeWithModifier(html, config, null);
}

export function sanitizeWithModifier(
  html: string,
  config: SanitizationConfig,
  modifierCallback: ((body: HTMLElement) => HTMLElement) | null,
) {
  let container = document.implementation.createHTMLDocument('sanitizerdoc').body;
  container.innerHTML = html;

  if (modifierCallback != null) {
    container = modifierCallback(container);
  }

  return sanitizeElement(container, config);
}
